module.exports = __webpack_public_path__ + "static/media/energy.d0d158fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/TeamBox/img/energy.svg
// module id = 76
// module chunks = 0